import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ExecutePortingRequestNowResponse } from 'src/app/core/proto/simon/sims/dtos';

import { ApiService } from 'src/app/core/services/api.service';
import { ExecutePortingRequestNowParams, UpdateSimInfoParams, UpdateSimInfoResponse } from '../';

@Injectable({
  providedIn: 'root',
})
export class SimonService {
  constructor(private readonly apiService: ApiService) {}

  /**
   * Update the sim info
   * @param updateSimInfoParams
   */
  updateSimInfo(
    updateSimInfoParams: UpdateSimInfoParams
  ): Observable<UpdateSimInfoResponse> {
    return this.apiService.post(
      `/v1/sims/sim/${updateSimInfoParams.iccid}`,
      updateSimInfoParams
    );
  }

  /**
   * Update the sim info
   * @param updateSimInfoParams
   */
  executePortingRequestNow(
    executePortingRequestNowParams: ExecutePortingRequestNowParams
  ): Observable<ExecutePortingRequestNowResponse> {
    return this.apiService.get(
      `/v1/msisdns/porting/${executePortingRequestNowParams.portingRequestUuid}/execute`,
    );
  }
}
